import { Component } from '@angular/core';

@Component({
  selector: 'app-mystry-box',
  templateUrl: './mystry-box.component.html',
  styleUrls: ['./mystry-box.component.css']
})


export class MystryBoxComponent {
  popUp=false;

openPopUp() {
this.popUp=true;
}
closePopup() {
this.popUp=false;
}

  
}
